var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspension(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2677_5774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 3.99085C23 5.64119 21.6547 6.98169 19.9986 6.98169C19.7384 6.98169 19.4846 6.95008 19.2434 6.88684L17.0859 4.71168C17.0288 4.47773 16.9971 4.23745 16.9971 3.99085C16.9971 2.34051 18.3424 1 19.9986 1C21.6547 1 23 2.34051 23 3.99085Z",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6839 8.28425L10.9625 17.9713L6.57139 13.5957L6.04471 13.0709L11.6478 7.49386L15.7661 3.39014L15.8676 3.49131L17.0796 4.69903L19.2942 6.9058L20.6839 8.28425Z",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19L10.2223 17.2128L4.00003 11",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90134 9.55518L16.5402 15.0373",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.88373 6.51392L19.8145 12.0277",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4098 10.0864L19.2434 6.89318L17.0796 4.71802L13.9576 1.56909",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92678 19.3307C6.97755 19.552 7.00293 19.7797 7.00293 20.0136C7.00293 21.664 5.65767 23.0045 4.00148 23.0045C2.34529 23.0045 1.00003 21.664 1.00003 20.0136C1.00003 18.3633 2.34529 17.0228 4.00148 17.0228C4.14743 17.0228 4.29337 17.0354 4.43298 17.0544L6.0384 13.0771L6.56508 13.602L10.8991 17.9966L6.92678 19.3307Z",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9625 17.9714L10.9054 17.9904",
    stroke: "#232323",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2677_5774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspension);
export default __webpack_public_path__ + "static/media/suspension.908411720b62006b24ca917bd53fe5f4.svg";
export { ForwardRef as ReactComponent };